import { ReactSVG } from "react-svg"
import Typography from "component-lib/Base/components/Typography"
import getContentUrl from "utils-lib/getContentUrl"
import { getWindow } from "utils-lib/getWindow"
import "./sevenCard.scss"

const ssrWindow = getWindow()

const Downloadcard = (cardList) => {
  const bodyWidth =
    ssrWindow.innerWidth > 0 ? ssrWindow.innerWidth : ssrWindow.screen.width

  return (
    <div className="cardWrapper" data-testid="DownloadCard">
      <div className="downloadcard">
        <div className="downloadcard-content">
          <div
            className="maax-font-weight-bold cardItemtitle"
            data-testid="DownloadCard-cardEyebrowText"
          >
            {cardList?.cardList?.cardEyebrowText}
          </div>
          <Typography
            className="cardHeading maax-font-weight-bold"
            variant={bodyWidth < 1025 ? "h4" : "h3"}
            style={{ color: "black" }}
            data-testid="DownloadCard-cardHeading"
          >
            {cardList?.cardList?.cardHeading}
          </Typography>
          <div
            className="flex-grow-1 cardItemsubText maax-font-weight-regular"
            data-testid="DownloadCard-cardBody"
          >
            {cardList?.cardList?.cardBody}
          </div>
        </div>
        <a
          className="maax-font-weight-regular"
          href={cardList?.cardList?.cardCtaURL}
          aria-label={`download ${cardList?.cardList?.cardHeading ?? ""}`}
          // eslint-disable-next-line react/no-unknown-property
          analytics_key={
            `download ${cardList?.cardList?.cardHeading}` ||
            cardList?.cardList?.analyticsKey ||
            `${cardList?.cardList?.cardHeading} ${cardList?.cardList?.cardCtaText} ${cardList?.cardList?.cardCtaURL}`
          }
          download
        >
          {cardList?.cardList?.cardCtaText}
          <span style={{ position: "relative", top: "0.3125rem" }}>
            <ReactSVG
              beforeInjection={(svg) => {
                svg.setAttribute("aria-label", "download")
                svg.setAttribute("title", "download")
              }}
              wrapper="span"
              src={getContentUrl(
                "/content/dam/wm/icons/utilities/20x20/green/download.svg",
              )}
            />
          </span>
        </a>
      </div>
    </div>
  )
}
export default Downloadcard
